import React from 'react';

const Label = React.forwardRef(({
  className = '',
  children,
  ...props
}, ref) => {
  return (
    <label
      ref={ref}
      className={`font-bold text-gray-700 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 uppercase ${className}`}
      {...props}
    >
      {children}
    </label>
  );
});

Label.displayName = 'Label';

export default Label;
